import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'spr-section-module-info',
	templateUrl: './section-info.component.html',
	host: {
		class:
			'flex items-center space-x-1 bg-grey-lime px-1 p-rounded ' +
			'p-shadow overflow-hidden pointer-events-auto cursor-pointer ',
	},
})
export class SectionInfoComponent {
	@Input() public showSettings = false;

	@Input() public isSuggestion = false;

	@Output() public settingsClick = new EventEmitter<MouseEvent>();

	public onSettingsClick(e: MouseEvent) {
		e.stopImmediatePropagation();
		e.stopPropagation();

		this.settingsClick.emit(e);
	}
}
